import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUsuarioCreacionModel } from '../../../modelos/Usuario/modeloUsuario'; // Reusamos el modelo para finalizar

const ConfirmarWhatsapp = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { addNewclienteUsuario } = useUsuarioCreacionModel();
    
    // Recuperamos los datos que venían del formulario anterior
    const datosPendientes = location.state?.datosPendientes;

    const [otp, setOtp] = useState(['', '', '', '', '', '']); // 6 dígitos
    const [cargando, setCargando] = useState(false);

    useEffect(() => {
        // Validación de seguridad: Si no hay datos, devolver al registro
        if (!datosPendientes) {
            toast.error("Datos de sesión perdidos. Por favor regístrate nuevamente.");
            navigate('/registro-cliente');
            return;
        }

        // AQUÍ DISPARAMOS EL ENVÍO DEL CÓDIGO AL ENTRAR
        enviarCodigoWhatsapp();
    }, []);

    const enviarCodigoWhatsapp = async () => {
        // Llamada a tu API para enviar el mensaje de WhatsApp
        console.log(`Enviando código a ${datosPendientes.numero}...`);
        toast.info(`Código enviado a WhatsApp: ${datosPendientes.numero}`);
    };

    const handleOtpChange = (element, index) => {
        if (isNaN(element.value)) return false;
        const codigo = [...otp];
        codigo[index] = element.value;
        setOtp(codigo);

        // Auto-focus al siguiente input
        if (element.nextSibling && element.value) {
            element.nextSibling.focus();
        }
    };

    const verificarCodigo = async (e) => {
        e.preventDefault();
        setCargando(true);
        const codigoIngresado = otp.join('');

        // 1. Validar OTP contra API (Simulado aquí)
        // const respuestaOtp = await api.validarOtp(datosPendientes.numero, codigoIngresado);
        
        // SIMULACIÓN: Digamos que el código es '123456' para pruebas
        if (codigoIngresado.length === 6) { 
            
            // 2. Si el código es correcto, llamamos a crear el usuario con flag verificado
            const exito = await addNewclienteUsuario(datosPendientes, true); // true = verificado

            if (exito) {
                toast.success("¡Identidad verificada! Cuenta creada.");
                navigate('/login');
            }
        } else {
            toast.error("Código incorrecto, inténtalo de nuevo.");
        }
        setCargando(false);
    };

    if(!datosPendientes) return null;

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4">
            <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full text-center">
                <div className="mb-6">
                    <span className="text-4xl">📱</span>
                    <h2 className="text-2xl font-bold mt-4 text-gray-800">Verifica tu WhatsApp</h2>
                    <p className="text-gray-600 mt-2 text-sm">
                        Hemos detectado una cuenta asociada al número <strong>{datosPendientes.numero}</strong>.
                        Ingresa el código que te acabamos de enviar para vincularla.
                    </p>
                </div>

                <form onSubmit={verificarCodigo}>
                    <div className="flex justify-center gap-2 mb-6">
                        {otp.map((data, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                className="w-10 h-12 border border-gray-300 rounded text-center text-xl focus:border-green-500 focus:ring-2 focus:ring-green-200 outline-none transition"
                                value={data}
                                onChange={e => handleOtpChange(e.target, index)}
                                onFocus={e => e.target.select()}
                            />
                        ))}
                    </div>

                    <button
                        type="submit"
                        disabled={cargando}
                        className={`w-full py-3 rounded-full text-white font-bold transition
                            ${cargando ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600 shadow-lg'}
                        `}
                    >
                        {cargando ? 'Verificando...' : 'Verificar Código'}
                    </button>
                </form>

                <button 
                    onClick={enviarCodigoWhatsapp}
                    className="mt-6 text-sm text-green-600 hover:underline"
                >
                    ¿No recibiste el código? Reenviar
                </button>
            </div>
        </div>
    );
};

export default ConfirmarWhatsapp;